import EnvironmentConfig from '../interfaces/EnvironmentConfig';

const preprodConfigs: EnvironmentConfig = {
    surveyJsKey:
        'YjMyZTEzNTYtMGEwNi00NGNlLTkxMWQtY2NhNjhkOGQ1NGUyOzE9MjAyNi0wMy0yMiwyPTIwMjYtMDMtMjIsND0yMDI2LTAzLTIy',
    dashboardClassic: 'https://dashboard-classic.casaretail.in',
    ruleServerUrl: 'https://api-preprod.casa.ajira.tech',//preprod
    ingressUrl:"https://ingress.casa.ajira.tech",
    apiServerUrl: 'https://api-preprod.customerstudio.ajira.tech', //preprod
    casaWebAppUrl: 'https://web.casa.ajira.tech',
    commerceConnect: 'https://commerce-connect-up.casa.ajira.tech',
    ruleUIUrl: 'https://rules.casa.ajira.tech',
    ticketDeskUrl: 'https://ticket-desk.casaretail.in',
    pwaUrl: 'casarewards.com',
    dashboard: 'https://dashboard.casaretail.in',
    tenantOnboardUrl: 'https://admin-preprod.casaretail.ai',
    supersetUrl: 'https://analytics.casa.ajira.tech',
    keycloakConfig: {
        url: `https://auth.casaretail.ai`,
        realm: `casa`,
        clientId: `casa_dashboard`,
    },
    socialMedia: {
        facebook: {
            appId: '915596119986283',
            configId: '967395289775221',
        },
        googleAds: {
            clientId:
                '273230167843-mdnnlq3creq5jouop3kfbvsjg2mqmpl6.apps.googleusercontent.com',
            redirectURI:
                'https://dashboard.casaretail.in/settings/integrations/social-media',
        },
    },
};

export default preprodConfigs;
